import React, { useState } from 'react'
import { ThemeButton } from '../../../static/styled/custom.styled';
import { ToolbarItem } from "@sc/Section.styled";
import './BaselineReportModal.css'
import swal from 'sweetalert2';
import { uploadFile } from "services/api/file";
import baselineReportServices from "services/api/baselineReport";
import { connectStore } from 'redux-box';
import { module as inviteCode } from "@st/inviteCode";
import { useEffect } from 'react';
import { MOCK_ASSESSMENT_ID } from '../../../utils/constant';
import {
    DropDownContainer,
    DropDownTitle
} from "../school-creator-form/SchoolIroEnable.styled";
import Select from "react-select";

const BaselineReportModal = (props) => {

    let initialState = { title: "", description: "", pdf: "", exam_type: {label: '', value: ''} }

    const [reports, setReports] = useState([]);
    const [showForm, setShowForm] = useState(false);
    const [editId, setEditId] = useState(null);
    const [formData, setFormData] = useState(initialState);
    const [loading, setLoading] = useState(false)
    const [fileLoading, setFileLoading] = useState(false)
    const [examOptions, setExamOptions] = useState([])

    const getBaselineReportsFunc = async () => {
        let school_id = props.inviteCode.schoolEditInfo.id
        let res = await baselineReportServices.getBaselineReports(school_id)
        if (res && res.success) {
            setReports(res.result)
        }
    }

    useEffect(() => {
        props.inviteCode.getIroExamTypes()
        getBaselineReportsFunc()
    }, [])

    useEffect(() => {
        if (props.inviteCode.iroExamTypes.length > 0) {
            let updatedTypes = props.inviteCode.iroExamTypes
                .filter((exam) => exam.id !== MOCK_ASSESSMENT_ID)
                .map((type) => {
                    return {
                        label: type.name,
                        value: type.id,
                    };
                });

            setExamOptions(updatedTypes);
        }
    }, [props.inviteCode.iroExamTypes]);

    const handleAddClick = () => {
        setFormData({ title: "", description: "", pdf: "" });
        setEditId(null);
        setShowForm(true);
    };

    const handleEditClick = (report) => {
        const selectedExam = examOptions.find(opt => opt.value === report.exam_type) || null;

        setFormData({
            title: report.title,
            description: report.description,
            pdf: report.pdf_link,
            exam_type: selectedExam
        });
        setEditId(report.id);
        setShowForm(true);
    };


    const handleDeleteClick = async (id) => {
        let res = await baselineReportServices.updateBaselineReport({ id: id, is_deleted: true })
        if (res && res.success) {
            await getBaselineReportsFunc()
        }
    };

    const handleChange = (e) => {
        let { name, value, files } = e.target;
        if (name === 'pdf' && files !== null) {
            setFileLoading(true);

            let fileSize = files[0].size / 1024 / 1024;
            if (fileSize > 15) {
                swal('Oops!', 'File size greater than 15MB ', 'warning')
            }
            else {
                uploadFile(files[0]).then(res => {
                    setFormData({ ...formData, pdf: res.file })
                    setFileLoading(false)
                });
            }
        } else {
            setFormData({ ...formData, [name]: value })
        }
    }

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            setLoading(true)
            const payload = {
                title: formData.title,
                description: formData.description,
                pdf_link: formData.pdf,
                school: props.inviteCode.schoolEditInfo.id,
                exam_type: formData.exam_type.value
            };
            if (editId) {
                let res = await baselineReportServices.updateBaselineReport({ ...payload, id: editId })
                if (res && res.success) {
                    await getBaselineReportsFunc()
                }
            } else {
                let res = await baselineReportServices.createBaselineReport(payload)
                if (res && res.success) {
                    await getBaselineReportsFunc()
                }
            }
            setShowForm(false);
            setFormData(initialState);
        } catch (err) {
            let err_message = (err.error && err.error.error_message) ? err.error.error_message : "Something went wrong"
            swal("Oops!", err_message, "error")
        }
        finally {
            setLoading(false)
        }
    };

    const handleExamTypeChange = (e) => {
        setFormData({ ...formData, exam_type: e })
    }

    return (
        <div className="school-baseline-report-container">
            {/* Header */}
            <div className="school-baseline-report-header">
                <h2 className="school-baseline-report-title">IRO School Reports</h2>
                <ThemeButton type='button' primary onClick={handleAddClick}>
                    Add New Report
                </ThemeButton>
            </div>

            {/* Table */}
            <table className="school-baseline-report-table">
                <thead>
                    <tr>
                        <th>Title</th>
                        <th>Description</th>
                        <th>Exam type</th>
                        <th>PDF</th>
                        <th>Actions</th>
                    </tr>
                </thead>
                <tbody>
                    {reports.length === 0 ? (
                        <tr>
                            <td colSpan="5" className="school-baseline-report-no-data">
                                No reports available
                            </td>
                        </tr>
                    ) : (
                        reports.map(function (report) {
                            return (
                                <tr key={report.id}>
                                    <td>{report.title}</td>
                                    <td>{report.description}</td>
                                    <td>{report.exam_type_name}</td>
                                    <td>
                                        <a style={{ cursor: 'pointer' }} target={'_blank'} href={report.pdf_link}>Pdf link</a>
                                    </td>
                                    <td>
                                        <div className="baseline-report-table-actions">
                                            <ToolbarItem primary onClick={() => handleEditClick(report)}>
                                                <div className="icon-container">
                                                    <i className="fa fa-pencil" />
                                                </div>
                                            </ToolbarItem>
                                            <ToolbarItem primary onClick={() => handleDeleteClick(report.id)}>
                                                <div className="icon-container">
                                                    <i className="fa fa-trash" />
                                                </div>
                                            </ToolbarItem>
                                        </div>
                                    </td>
                                </tr>
                            );
                        })
                    )}
                </tbody>
            </table>

            {/* Form */}
            {showForm && (
                <form className="school-baseline-report-form" onSubmit={handleSubmit}>
                    <input
                        type="text"
                        name="title"
                        placeholder="Enter Title"
                        value={formData.title}
                        onChange={handleChange}
                    />
                    <textarea
                        name="description"
                        placeholder="Enter Description"
                        value={formData.description}
                        onChange={handleChange}
                    />
                    <DropDownContainer>
                        <DropDownTitle>EXAM TYPE</DropDownTitle>
                        <Select
                            styles={{
                                placeholder: (provided, state) => ({
                                    ...provided,
                                    color: "rgba(0, 0, 0, 0.2)",
                                }),
                            }}
                            placeholder={"select exam type"}
                            onChange={handleExamTypeChange}
                            options={examOptions.length > 0 && examOptions}
                            isMulti={false}
                            value={formData.exam_type}
                            menuPlacement="auto" // auto, top, or bottom
                            menuPosition="fixed"
                        />
                    </DropDownContainer>
                    <div className="baseline-report-file-upload-wrapper">
                        <label className="baseline-report-custom-file-upload">
                            <input
                                type="file"
                                name="pdf"
                                accept="application/pdf"
                                onChange={handleChange}
                            />
                            {formData.pdf ? "Update file" : "Choose File"}
                        </label>

                        {/* Show custom file name */}
                        {!fileLoading && formData.pdf && (
                            <span className="baseline-report-file-name">
                                {formData.pdf.split("/").pop()}
                            </span>
                        )}
                        {
                            fileLoading &&
                            <img
                                alt="loading"
                                width="40"
                                height="40"
                                src={require("static/img/Theme-loader.gif")}
                            />
                        }
                    </div>

                    <div className="baseline-school-report-bottom-container">
                        {loading ? <img
                            alt="loading"
                            width="40"
                            height="40"
                            src={require("static/img/Theme-loader.gif")}
                        /> :
                            <ThemeButton primary type="submit" disabled={loading}>
                                {editId ? "Update Report" : "Submit Report"}
                            </ThemeButton>}
                    </div>
                </form>
            )}
        </div>
    );
};

export default connectStore({
    inviteCode
})(BaselineReportModal)